// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"item_dropdown__33y8_","open":"item_open__KZ_R3"};